import {icon} from '#core/utils/style-utils.js';

import {registerTileSchema} from '#core/application/schema-registry.js';

import FAVORITE_ICON from './favorite-icon.palette-schema.yaml';

registerTileSchema(FAVORITE_ICON);

export function generateFavoriteIcon(TILE) {
    return {
        favoriteIcon: icon(TILE.FAVORITE_ICON_COLOR),
        favoriteIconToggled: icon(TILE.FAVORITE_ICON_TOGGLED_COLOR),
    };
}
